window.VegasCatalog.Search = {
	body: $('body'),
	container: $('.vg-search'),
	wrapper: $('#vg-search--wrapper'),
	tm: null,

	open: function ($self, options) {
		this.body.addClass('search-open');
		$('html, body').animate({scrollTop: 0}, 500);

		this.wrapper.show();
		VegasCatalog.Search.request($self, options);
	},

	close: function ($self) {
		this.body.removeClass('search-open');
		this.wrapper.hide();
		$self.blur();
	},

	request: function ($self, options) {
		let val = $self.val();
		options = options || {};

		let params = {search: val};

		let searchRequest = function () {
			$.get('/search/lookup', params, function (data) {
				VegasCatalog.Search.setView(data);
			})
		};

		if (typeof options.timeout === 'undefined' || options.timeout === true) {
			clearTimeout(this.tm);
			this.tm = setTimeout(searchRequest, 500);
		} else {
			searchRequest();
		}
	},

	setView: function (data) {
		$("#vg-search--wrapper").html(data.view);
	}
};

$(document).ready(function () {
	VegasCatalog.Search.container.find('input').on('focus', function () {
		VegasCatalog.Search.open($(this), {
			timeout: false,
		});

		return false;
	});

	VegasCatalog.Search.container.find('input').on('search', function () {
		VegasCatalog.Search.request($(this), {
			timeout: false,
		});

		return false;
	});

	VegasCatalog.Search.container.find('input').on('keyup', function () {
		VegasCatalog.Search.request($(this));

		return false;
	});

	VegasCatalog.Search.container.on('click', '[data-keysearch]', function () {
		VegasCatalog.Search.container.find('input')
			.val($(this).data('keysearch'))
			.trigger('search');

		return false;
	});

	$('[data-dissmis="vg-search"]').click(function () {
		VegasCatalog.Search.close($(this));

		return false;
	});

	$(document).keyup(function (e) {
		if (e.key === "Escape" && VegasCatalog.Search.body.hasClass('search-open')) {
			VegasCatalog.Search.close($('.vg-search').find('input'));
		}
	});
});